import type { NavIcon } from "../navIcon";

export interface AppsMenuLink {
  id: string;
  label: string;
  to: string;
  icon?: NavIcon;
  matchPrefixes: string[];
}

export interface AppsMenuParent {
  id: string;
  label: string;
  icon: NavIcon;
  children: AppsMenuLink[];
}

export type AppsMenuEntry = AppsMenuLink | AppsMenuParent;

export const isAppsMenuParent = (
  entry: AppsMenuEntry
): entry is AppsMenuParent => "children" in entry;

export const matchesPathPrefix = (pathname: string, path: string): boolean => {
  const base = path.endsWith("/") ? path.slice(0, -1) : path;

  return pathname === base || pathname.startsWith(`${base}/`);
};

export const isAppsMenuLinkActive = (
  pathname: string,
  link: AppsMenuLink
): boolean =>
  link.matchPrefixes.some((path) => matchesPathPrefix(pathname, path));

export const isAppsMenuActive = (
  pathname: string,
  entries: AppsMenuEntry[]
): boolean =>
  entries.some((entry) =>
    isAppsMenuParent(entry)
      ? entry.children.some((child) => isAppsMenuLinkActive(pathname, child))
      : isAppsMenuLinkActive(pathname, entry)
  );
